export interface SplitJitsiUrl {
    /** Jitsi origin plus any deployment sub-path, always ending with "/". */
    domain: string;
    /** Room name taken from the last URL path segment, when the URL points to a meeting. */
    roomName?: string;
}

/**
 * Splits a Jitsi URL configured in a map into the Jitsi domain and, when the URL
 * points to a meeting (e.g. "https://meet.example.com/MyRoom"), the room name.
 * Jitsi itself joins the room named by the URL path, so a URL with a path is
 * treated the same way here instead of silently dropping the path.
 * A bare host ("meet.example.com") is assumed to be https.
 */
export function splitJitsiUrl(jitsiUrl: string): SplitJitsiUrl {
    const withScheme = /^https?:\/\//i.test(jitsiUrl) ? jitsiUrl : `https://${jitsiUrl}`;
    const url = new URL(withScheme);
    const segments = url.pathname.split("/").filter((segment) => segment.length > 0);
    const roomSegment = segments.pop();
    const domain = `${url.origin}/${segments.map((segment) => `${segment}/`).join("")}`;

    if (roomSegment === undefined) {
        return { domain };
    }

    return { domain, roomName: decodeURIComponent(roomSegment) };
}
